import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../store/tabSlice";
import { StoreService } from "../../services/store-service";
import { useTheme } from "../../ThemeContext"; // ✅ استفاده از تم
import "./ServiceItem.css";

interface ServiceItemProps {
  id: number;
  name: string;
  icon: string;
  onClick: () => void;
}

const ServiceItem: React.FC<ServiceItemProps> = ({ id, name, icon, onClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isDarkMode } = useTheme(); // ✅ گرفتن تم فعلی

  // تنظیم مسیر آیکون بر اساس تم
  const getIconPath = () => {
    const [namePart, ext] = icon.split(".");
    const finalName = isDarkMode ? `${namePart}-dark.${ext}` : icon;
    return `/assets/icons/categories/${finalName}`;
  };

  const handleServiceClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    StoreService.SetData("selectedService", id);
    dispatch(setActiveTab("appointments"));
    onClick();
    navigate(`/times?service=${id}`);
  };

  return (
    <Link
      to={`/times?service=${id}`}
      onClick={handleServiceClick}
      className="service-item-link"
      aria-label={`سرویس ${name}`}
    >
      <div className="service-item-icon-container">
        <img
          src={getIconPath()} // ✅ آیکون وابسته به تم
          alt={name}
          className="service-item-icon"
        />
      </div>
      <p className="service-item-name">{name}</p>
    </Link>
  );
};

export default ServiceItem;
